import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["error"]

  buildInspections(event) {
    const select = this.element.querySelector("select.inspection-types")
    const selected = Array.from(select?.selectedOptions || [])
    if (selected.length === 0) {
      event.preventDefault()
      this.showError("Select at least one inspection type before adding.")
      return
    }
    event.preventDefault()
    this.hideError()
    const optionsForNew = []
    const existingDecisions = new Map()
    selected.forEach(option => {
      const existingInspectionId = option.dataset.existingInspectionId
      if (existingInspectionId) {
        const existingVisitId = option.dataset.existingVisitId
        if (!existingDecisions.has(existingInspectionId)) {
          const label = option.text?.trim() || "inspection"
          if (existingVisitId) {
            const goToVisit = window.confirm(`An active ${label} attempt is already open. Go to that attempt instead?`)
            existingDecisions.set(existingInspectionId, goToVisit ? "visit" : "new")
            if (goToVisit) {
              window.open(this.editInspectionVisitUrl(existingInspectionId, existingVisitId), "_blank")
              return
            }
          } else {
            const useExisting = window.confirm(`An active ${label} inspection already exists. Start a new attempt on that inspection instead?`)
            existingDecisions.set(existingInspectionId, useExisting ? "inspection" : "new")
            if (useExisting) {
              window.open(this.editInspectionUrl(existingInspectionId), "_blank")
              return
            }
          }
        } else if (existingDecisions.get(existingInspectionId) !== "new") {
          return
        }
      }
      optionsForNew.push(option)
    })
    if (optionsForNew.length === 0) {
      return
    }
    const basePath = event.currentTarget.dataset.inspectable
    const baseInspectableId = this.inspectableIdFromPath(basePath)
    const firstInspectableId = optionsForNew[0]?.dataset.permitId || baseInspectableId
    const inspectionSet = optionsForNew.map(option => {
      const inspectableId = option.dataset.permitId || baseInspectableId
      return `${inspectableId},${option.value}`
    }).join(",")
    const inspectablePath = this.inspectablePath(basePath, firstInspectableId)
    if (!inspectablePath) {
      this.showError("Unable to build inspection form link.")
      return
    }
    const url = `${inspectablePath}/inspections/new_multiple?inspection_set=${encodeURIComponent(inspectionSet)}`
    window.open(url, "_blank")
  }

  handleSingleInspection(event) {
    const existingInspectionId = event.currentTarget.dataset.existingInspectionId
    if (!existingInspectionId) {
      return
    }
    const existingVisitId = event.currentTarget.dataset.existingVisitId
    const label = event.currentTarget.dataset.inspectionLabel || "inspection"
    if (existingVisitId) {
      const goToVisit = window.confirm(`An active ${label} attempt is already open. Go to that attempt instead?`)
      if (!goToVisit) {
        return
      }
      event.preventDefault()
      window.open(this.editInspectionVisitUrl(existingInspectionId, existingVisitId), "_blank")
      return
    }
    const useExisting = window.confirm(`An active ${label} inspection already exists. Start a new attempt on that inspection instead?`)
    if (!useExisting) {
      return
    }
    event.preventDefault()
    window.open(this.editInspectionUrl(existingInspectionId), "_blank")
  }

  inspectableIdFromPath(path) {
    if (!path) return null
    const parts = path.split("/").filter(part => part !== "")
    return parts[parts.length - 1]
  }

  inspectablePath(basePath, inspectableId) {
    if (!basePath) return ""
    if (!inspectableId) return basePath
    const parts = basePath.split("/")
    parts[parts.length - 1] = inspectableId
    return parts.join("/")
  }

  editInspectionUrl(inspectionId) {
    return `/inspections/${inspectionId}/edit?start_attempt=true`
  }

  editInspectionVisitUrl(inspectionId, visitId) {
    return `/inspections/${inspectionId}/inspection_visits/${visitId}/edit`
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
